import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  textEditorContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end',
    gap: 50,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: 20,
      width: '100%'
    }
  },
  input: {
    width: 'calc(50% - 25px)',
    padding: 0,
    margin: 0,
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    },
    [theme.breakpoints.down('xs')]: {
      width: '100%'
    }
  },
  requiredFieldContainer: {
    height: 30
  },
  requiredField: {
    color: theme.palette.error.main
  }
}))
export default useStyles
